module.exports = __webpack_public_path__ + "img/menu-safety-active.344c4b53.svg";